import axios from '@/plugins/api.request'

/**
 * 创建的团队列表
 * @param {*} params
 */
export const list = (params) => {
  return axios.request({
    method: 'get',
    url: 'player.team/list',
    params
  })
}

/**
 * 创建团队
 * @param {*} data
 */
export const add = (data) => {
  return axios.request({
    method: 'post',
    url: 'player.team/create',
    data
  })
}

/**
 * 更新团队
 * @param {*} data
 */
export const update = (data) => {
  return axios.request({
    method: 'post',
    url: 'player.team/update',
    data
  })
}

/**
 * 解散团队
 * @param {*} data
 */
export const disband = (params) => {
  return axios.request({
    method: 'get',
    url: 'player.team/disband',
    params
  })
}

/**
 * 团队成员列表
 * @param {*} data
 */
export const memberList = (params) => {
  return axios.request({
    method: 'get',
    url: 'player.team/memberList',
    params
  })
}

/**
 * 快速添加成员
 * @param {*} data
 */
export const addFastMember = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.UcenterTeam.AddFastMember',
    data
  })
}

/**
 * 添加成员
 * @param {*} params
 */
export const addMember = (params) => {
  return axios.request({
    method: 'get',
    url: 'player.team/addMember',
    params
  })
}

/**
 * 移除成员
 * @param {*} params
 */
export const delMember = (params) => {
  return axios.request({
    method: 'get',
    url: 'player.team/delMember',
    params
  })
}

/**
 * 退出团队
 * @param {*} params
 */
export const exitTeam = (params) => {
  return axios.request({
    method: 'get',
    url: 'player.team/exitTeam',
    params
  })
}

/**
 * 获取可参赛的团队
 * @param {*} params
 */
export const unjoinMatchTeams = (params) => {
  return axios.request({
    method: 'get',
    url: 'player.team/getUnjoinMatchTeams',
    params
  })
}